import {pluck, add, reduce, sort, slice} from 'ramda'
import {DisplayToggles} from "./DisplayToggles"
import {SuggestedTrades} from "./SuggestedTrades"
import {ProgressBar} from "./ProgressBar"
import {useState,useEffect} from "react"
import {isNil} from "ramda"
import ToolTip from "./ToolTip"
import {useTeams, useTCData} from '../../context'


export const BottomDisplay = () => {
    const [total1, setTotal1] = useState(0)
    const [total2, setTotal2] = useState(0)
    const [difference, setDifference] = useState(0)
    const [closest, setClosest] = useState([])

    const {team1, team2} = useTeams()
    const {activeTCData} = useTCData()

    useEffect(() => {
        const findClosestElements = (k, x) => {
            const sortedData = sort((num1, num2)=> Math.abs(num1.total -x) - Math.abs(num2.total - x),activeTCData)
            return slice(0, k, sortedData)
        };
        const totals1 = pluck('total', team1)
        const newTotal1 = reduce(add, 0, totals1)
        const totals2 = pluck('total', team2)
        const newTotal2 = reduce(add, 0, totals2)
        const newDifference = newTotal1 - newTotal2
        if (!isNil(activeTCData)) {
            const newClosest = findClosestElements(3, Math.abs(newDifference))
            setClosest(newClosest)
        }
        setTotal1(newTotal1)
        setTotal2(newTotal2)
        setDifference(newDifference)
    }, [team1, team2, activeTCData])
    
    return (
        <div> 
            <DisplayToggles />
            <div className="is-flex is-justify-content-center" style={{fontSize: ".8rem", marginTop: ".5rem"}}>
                Replacement Level Value?
                <span style={{marginLeft: ".5rem"}}><ToolTip text={["Trading more players away than you’re getting back? Add the league size dependent replacement value into the search box for each roster spot that you are churning:", "10 Team Replacement Level", "12 Team Replacement Level", "15 Team Replacement Level", "20 Team Replacement Level", "30 Team Replacement Level"]} /></span>
            </div>
            <ProgressBar total1={total1} total2={total2} difference={difference} />
            <SuggestedTrades difference={difference} closest={closest} summedTot={total1 + total2} />
        </div>
    )
}